import { useEffect, useState, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

export default function PageTransition({ children }: { children: ReactNode }) {
  const location = useLocation();
  const [show, setShow] = useState(true);

  useEffect(() => {
    queueMicrotask(() => setShow(false));
    const timer = requestAnimationFrame(() => {
      requestAnimationFrame(() => setShow(true));
    });
    return () => cancelAnimationFrame(timer);
  }, [location.pathname]);

  return (
    <div className={`page-transition ${show ? 'page-visible' : 'page-hidden'}`}>
      {children}
    </div>
  );
}
